import { bool, shape, string } from 'prop-types';

// TODO: Refactor to what model will actually be
const tmsTrackActivityShape = shape({
  initiatorName: string,
  note: string,
  driverCity: string,
  driverState: string,
  eventId: string,
  eventTime: string,
  eventType: string,
  loadId: string,
  isAutomated: bool,
});

export default tmsTrackActivityShape;
